"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WS_CHANNEL_RECEIVED_ALERT_NOTIFICATION = void 0;
exports.WS_CHANNEL_RECEIVED_ALERT_NOTIFICATION = 'notifications.received_alert_notification';
//# sourceMappingURL=websocket.js.map